import { WorkModel } from '@Entities/work/work'

export const WORK_HOLD_STATUS = {
    MLC_OVERCLAIM: 104,
    MLC_DISPUTE: 105,
    MLC_SONG_LEGAL: 101,
    SHARE_ISSUE: 141,
    SHARES_MISSING: 142,
    HOLD: 62,
    STATUTORY_TERMINATION_HOLD: 1000,
}

export type WorkHoldStatus = (typeof WORK_HOLD_STATUS)[keyof typeof WORK_HOLD_STATUS]

export type WorkHoldStatusNames = keyof typeof WORK_HOLD_STATUS

export const isWorkOnHold = (workItem: WorkModel): boolean => !!workItem.holdTypeId

export const getHoldText = (status?: number) => {
    switch (status) {
        case WORK_HOLD_STATUS.MLC_OVERCLAIM:
            return 'Overclaim'
        case WORK_HOLD_STATUS.MLC_DISPUTE:
            return 'Dispute'
        case WORK_HOLD_STATUS.HOLD:
            return 'Hold'
        case WORK_HOLD_STATUS.MLC_SONG_LEGAL:
            // This should be "Legal" once 101 and 104 are separated in the filter logic.
            return 'Dispute'
        case WORK_HOLD_STATUS.SHARE_ISSUE:
            return 'Share Issue'
        case WORK_HOLD_STATUS.SHARES_MISSING:
            return 'Share Missing'
        case WORK_HOLD_STATUS.STATUTORY_TERMINATION_HOLD:
            return 'Statutory Termination Hold'
        default:
            return null
    }
}

export const getHoldTypeIdFromName = (name: string): number[] | null => {
    switch (name) {
        case 'MLC_OVERCLAIM':
            return [WORK_HOLD_STATUS.MLC_OVERCLAIM]
        case 'MLC_DISPUTE':
            // For now, hold status 101 and 105 will be applied to the catalog search when using the Dispute filter.
            return [WORK_HOLD_STATUS.MLC_DISPUTE, WORK_HOLD_STATUS.MLC_SONG_LEGAL]
        case 'MLC_SONG_LEGAL':
            return [WORK_HOLD_STATUS.MLC_SONG_LEGAL]
        case 'SHARE_ISSUE':
            return [WORK_HOLD_STATUS.SHARE_ISSUE]
        case 'HOLD':
            return [WORK_HOLD_STATUS.HOLD]
        case 'SHARES_MISSING':
            return [WORK_HOLD_STATUS.SHARES_MISSING]
        case 'STATUTORY_TERMINATION_HOLD':
            return [WORK_HOLD_STATUS.STATUTORY_TERMINATION_HOLD]
        default:
            return null
    }
}

export const getHoldColor = (status?: number) => {
    switch (status) {
        case 104:
            return 'orange'
        case 105:
        case 101: // For now, hold status 101 and 105 will be treated the same, as Dispute
            return 'black'
        case 141:
        case 142:
        case 62:
            return 'yellow'
        default:
            return 'blue'
    }
}
